import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando } from './queryClient';
import { CatalogProduct } from '../types/entities';
import { ProductRequest } from '../types/dtos';
import { Page } from '../types';

/**
 * Catálogo global de produtos. Uma chave de domínio só: o cadastro no painel e a
 * gaveta das etapas leem a mesma base, então salvar no admin precisa derrubar o
 * cache das duas telas.
 */
export const CHAVES_CATALOGO = {
  dominio: ['catalogo'] as const,
  /** Lista paginada do painel; a página, o usePagina põe no fim. */
  admin: ['catalogo', 'admin'] as const,
  daEtapa: (userId: string, categoryId: string) =>
    ['catalogo', 'etapa', userId, categoryId] as const,
  /** Filtros dentro da chave: trocar a busca ou a categoria é outra query. */
  busca: (q: string, categoryId: string) =>
    ['catalogo', 'busca', q, categoryId] as const,
};

const CatalogService = {
  /**
   * GET /api/v1/users/{userId}/product-suggestions?categoryId=
   * Categoria inteira já ordenada: o que o usuário tem primeiro. A tela mostra os
   * 3 primeiros na gaveta e o "ver mais" abre o resto sem nova requisição.
   */
  suggestions: (userId: string, categoryId: string): Promise<AxiosResponse<CatalogProduct[]>> =>
    api.get(`/users/${userId}/product-suggestions`, { params: { categoryId } }),

  /**
   * GET /api/v1/products?q=&categoryId=&page= → Page<CatalogProduct>
   * O catálogo inteiro para o usuário procurar, 10 por página.
   */
  buscar: (q: string, categoryId: string, page: number): Promise<AxiosResponse<Page<CatalogProduct>>> =>
    api.get('/products', { params: { q: q || undefined, categoryId: categoryId || undefined, page } }),

  // ── Painel administrativo (DOMINUS) ──────────────────────────────────────

  // GET /api/v1/admin/products?page= → Page<CatalogProduct> — inclui os ocultos do app
  getPage: (page: number): Promise<AxiosResponse<Page<CatalogProduct>>> =>
    api.get('/admin/products', { params: { page } }),

  // POST /api/v1/admin/products
  create: (data: ProductRequest): Promise<AxiosResponse<CatalogProduct>> =>
    api.post('/admin/products', data).then(invalidando(CHAVES_CATALOGO.dominio)),

  // PUT /api/v1/admin/products/{id}
  update: (id: string, data: ProductRequest): Promise<AxiosResponse<CatalogProduct>> =>
    api.put(`/admin/products/${id}`, data).then(invalidando(CHAVES_CATALOGO.dominio)),

  // DELETE /api/v1/admin/products/{id}
  remove: (id: string): Promise<AxiosResponse<void>> =>
    api.delete(`/admin/products/${id}`).then(invalidando(CHAVES_CATALOGO.dominio)),
};

export default CatalogService;
